const DEFAULT_ROW = 2;
const TABLET_COLUMN = 3;

const showCard = ($card) => {
  if ($card.style.display !== 'block') {
    $card.style.display = 'block';
    $card.style.opacity = 0;
    setTimeout(() => {
      $card.style.opacity = 1;
    }, 300);
  }
};

const isLayout513OnTablet = (layoutType) => {
  return layoutType === 'fc-layout-513' && window.innerWidth < 960 && window.innerWidth >= 600;
}

export const openMore = (w, d, layouts) => {
  layouts.forEach((layout) => {
    [...d.querySelectorAll(`.${layout}`)].forEach(($layer) => {
      if (!$layer.querySelector('.container--more-btn')) {
        return;
      }

      let index = 1;
      const column = isLayout513OnTablet(layout) ? TABLET_COLUMN : Number($layer.querySelector('.container__cards').dataset.columnCount);
      const columnCount = column * DEFAULT_ROW;
      const cardLen = $layer.querySelectorAll('.container__card').length;
      const $footer = $layer.querySelector('.container__footer');

      if (columnCount >= cardLen) {
        $footer.style.display = 'none';
      }

      $layer.querySelector('.container__load-more-btn').addEventListener('click', () => {
        const startBlockIndex = index * columnCount + 1;
        const endBlockIndex = (index + 1) * columnCount;
        const $block = `.container__card:nth-child(n + ${startBlockIndex}):nth-child(-n + ${endBlockIndex})`;

        [...$layer.querySelectorAll($block)].forEach(($card) => {
          showCard($card);
        });
        index += 1;

        if (endBlockIndex >= cardLen) {
          $footer.style.display = 'none';
        }
      });
    });
  });
};
